"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HintOverlay = void 0;
var React = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var Hint_1 = require("./Hint");
var HintOverlay = /** @class */ (function (_super) {
    __extends(HintOverlay, _super);
    function HintOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.hasTouch = document.querySelector("html").classList.contains("touchevents");
        _this.toggle = function () {
            var disabled = _this.props.disabled;
            if (!disabled) {
                _this.setState({ show: !_this.state.show });
            }
        };
        _this.hide = function () {
            _this.setState({ show: false });
        };
        _this.show = function () {
            var disabled = _this.props.disabled;
            if (!disabled) {
                _this.setState({ show: true });
            }
        };
        _this.state = {
            show: false
        };
        return _this;
    }
    HintOverlay.prototype.render = function () {
        var _a = this.props, id = _a.id, hint = _a.hint, _b = _a.placement, placement = _b === void 0 ? "bottom" : _b, children = _a.children;
        var show = this.state.show;
        var hintClose = this.hasTouch ? this.hide : null;
        var childEvents = this.hasTouch ? { onClick: this.toggle } : { onMouseEnter: this.show, onMouseLeave: this.hide };
        var childClasses = {
            className: show ? "".concat(children.props.className, " active") : children.props.className
        };
        return (React.createElement("div", null,
            React.cloneElement(children, __assign(__assign({}, childEvents), childClasses)),
            React.createElement(react_bootstrap_1.Overlay, { key: id, show: this.state.show, onHide: this.hide, rootClose: true, target: null },
                React.createElement(Hint_1.Hint, { text: hint, close: hintClose }))));
    };
    ;
    return HintOverlay;
}(React.Component));
exports.HintOverlay = HintOverlay;
